import { FileShareTypes } from './models/enums';
import { EvidenceStatus, EvidenceType } from './evidence.models';

export function toEvidenceStatusString(status?: EvidenceStatus): string {
  if (!status) {
    return '';
  }

  switch (status) {
    case EvidenceStatus.Active:
      return 'evidence-status-active';
    case EvidenceStatus.QueuedForDeletion:
      return 'evidence-status-queued-for-delete';
    case EvidenceStatus.Deleted:
      return 'evidence-status-deleted';
  }
}

export function toEvidenceTypeString(type?: EvidenceType): string {
  if (!type) {
    return 'file-type-other';
  }

  switch (type) {
    case EvidenceType.Video:
      return 'file-type-video';
    case EvidenceType.Audio:
      return 'file-type-audio';
    case EvidenceType.Document:
      return 'file-type-document';
    case EvidenceType.Image:
      return 'file-type-photo';
  }
}

export function toEvidenceTypeCleanString(type?: EvidenceType): string {
  if (!type) {
    return 'file-type-other';
  }

  switch (type) {
    case EvidenceType.Video:
      return 'file-type-video';
    case EvidenceType.Audio:
      return 'file-type-audio';
    case EvidenceType.Document:
      return 'file-type-document';
    case EvidenceType.Image:
      return 'file-type-photo';
  }
}

export function toEvidenceImage(url: string, type: EvidenceType): string {
  if (url !== null && url !== '') {
    return url;
  }

  const picBaseUrl = '/assets/images/';

  switch (type) {
    case EvidenceType.Other:
      return `${picBaseUrl}file_document.svg`;
    case EvidenceType.Video:
      return `${picBaseUrl}file_video.svg`;
    case EvidenceType.Audio:
      return `${picBaseUrl}file_audio.svg`;
    case EvidenceType.Document:
      return `${picBaseUrl}file_document.svg`;
    case EvidenceType.Image:
      return `${picBaseUrl}file_photo.svg`;
  }
}

export function convertDuration(duration?: number): string {
  if (duration) {
    let h, m, s;

    s = Math.floor(duration / 1000);
    m = Math.floor(s / 60);
    s = s % 60;
    h = Math.floor(m / 60);
    m = m % 60;
    const d = Math.floor(h / 24);
    h = h % 24;
    h += d * 24;

    h = h.toString().padStart(2, '0');
    m = m.toString().padStart(2, '0');
    s = s.toString().padStart(2, '0');

    return `${h}:${m}:${s}`;
  }

  return '00:00:00';
}

export function getDayDifference(differenceDate: string | undefined | Date): number {
  if (differenceDate !== undefined) {
    const date = new Date();
    const tempDifferenceDate = new Date(differenceDate);

    const difference = tempDifferenceDate.getTime() - date.getTime();
    const dayDifference = Math.ceil(difference / (1000 * 3600 * 24));

    return dayDifference;
  }

  return 0;
}

export function toEvidenceShareType(type?: FileShareTypes): string {
  switch (type) {
    case FileShareTypes.View:
      return 'file-share-type-view';
    case FileShareTypes.Delete:
      return 'file-share-type-delete';
    case FileShareTypes.Edit:
      return 'file-share-type-edit';
    case FileShareTypes.Full:
      return 'select-share-type-option-full';
    case FileShareTypes.Share:
      return 'file-share-type-share';
    default:
      return 'file-share-type-unknown';
  }
}
